// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================================= */
/* 🌟 WHATS NEW PAGE — STANDALONE CSS (prefix: wn-)          */
/* ========================================================= */

.wn-container {
  color: #222;
  min-height: 100vh;
  padding: 80px 20px 50px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

/* ======= TITLE ======= */
.wn-title {
  text-align: center;
  color: #333;
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 30px;
  border-bottom: 2px solid #ccc;
  padding-bottom: 10px;
}

/* ======= FORM (Admin Only) ======= */
.wn-form {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 40px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.wn-form-title {
  font-size: 1.3rem;
  color: #333;
  margin-bottom: 15px;
  text-align: center;
}

.wn-input,
.wn-textarea {
  width: 100%;
  background: #fff;
  border: 1px solid #ccc;
  color: #222;
  font-size: 0.95rem;
  padding: 10px 12px;
  border-radius: 8px;
  outline: none;
  margin-bottom: 15px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.wn-input:focus,
.wn-textarea:focus {
  border-color: #2196f3;
  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.15);
}

/* ======= BUTTONS ======= */
.wn-btn-group {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.wn-btn {
  padding: 8px 18px;
  border-radius: 8px;
  border: none;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.1s;
}

.wn-btn:hover {
  transform: translateY(-1px);
}

.wn-btn-primary {
  background-color: #2196f3;
  color: #fff;
}

.wn-btn-primary:hover {
  background-color: #1976d2;
}

.wn-btn-cancel {
  background-color: #e0e0e0;
  color: #333;
}

.wn-btn-cancel:hover {
  background-color: #d5d5d5;
}

.wn-btn-edit {
  background-color: #4caf50;
  color: #fff;
}

.wn-btn-edit:hover {
  background-color: #43a047;
}

.wn-btn-delete {
  background-color: #f44336;
  color: #fff;
}

.wn-btn-delete:hover {
  background-color: #d32f2f;
}

/* ======= LIST / NEWS ITEMS ======= */
.wn-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.wn-item {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 12px;
  padding: 20px;
  transition: transform 0.15s, box-shadow 0.15s;
}

.wn-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
}

.wn-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.wn-item-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #1890ff;
}

.wn-actions {
  display: flex;
  gap: 8px;
}

.wn-content {
  font-size: 1rem;
  line-height: 1.6;
  color: #444;
  margin-bottom: 8px;
  white-space: pre-wrap;
}

.wn-date {
  font-size: 0.85rem;
  color: #888;
  text-align: right;
}

/* ======= STATES ======= */
.wn-loading,
.wn-empty {
  text-align: center;
  color: #777;
  font-size: 1rem;
  margin-top: 30px;
}

/* ======= MOBILE (Responsive) ======= */
@media (max-width: 768px) {
  .wn-container {
    padding: 15px 12px 30px;
  }
  
  .wn-list {
  margin-top: 30px;
}


  .wn-form {
    padding: 15px;
  }

  .wn-btn-group {
    flex-direction: column;
  }

  .wn-btn {
    width: 100%;
  }

  .wn-item {
    padding: 15px;
  }

  .wn-item-title {
    font-size: 1.1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/WhatsNew.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D,8DAA8D;AAC9D,8DAA8D;;AAE9D;EACE,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,4DAA4D;AAC9D;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;;EAEE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;;EAEE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE;IACE,uBAAuB;EACzB;;EAEA;EACA,gBAAgB;AAClB;;;EAGE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* ========================================================= */\n/* 🌟 WHATS NEW PAGE — STANDALONE CSS (prefix: wn-)          */\n/* ========================================================= */\n\n.wn-container {\n  color: #222;\n  min-height: 100vh;\n  padding: 80px 20px 50px;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n/* ======= TITLE ======= */\n.wn-title {\n  text-align: center;\n  color: #333;\n  font-size: 2rem;\n  font-weight: 600;\n  margin-bottom: 30px;\n  border-bottom: 2px solid #ccc;\n  padding-bottom: 10px;\n}\n\n/* ======= FORM (Admin Only) ======= */\n.wn-form {\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 40px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n}\n\n.wn-form-title {\n  font-size: 1.3rem;\n  color: #333;\n  margin-bottom: 15px;\n  text-align: center;\n}\n\n.wn-input,\n.wn-textarea {\n  width: 100%;\n  background: #fff;\n  border: 1px solid #ccc;\n  color: #222;\n  font-size: 0.95rem;\n  padding: 10px 12px;\n  border-radius: 8px;\n  outline: none;\n  margin-bottom: 15px;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.wn-input:focus,\n.wn-textarea:focus {\n  border-color: #2196f3;\n  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.15);\n}\n\n/* ======= BUTTONS ======= */\n.wn-btn-group {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n}\n\n.wn-btn {\n  padding: 8px 18px;\n  border-radius: 8px;\n  border: none;\n  font-size: 0.95rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s, transform 0.1s;\n}\n\n.wn-btn:hover {\n  transform: translateY(-1px);\n}\n\n.wn-btn-primary {\n  background-color: #2196f3;\n  color: #fff;\n}\n\n.wn-btn-primary:hover {\n  background-color: #1976d2;\n}\n\n.wn-btn-cancel {\n  background-color: #e0e0e0;\n  color: #333;\n}\n\n.wn-btn-cancel:hover {\n  background-color: #d5d5d5;\n}\n\n.wn-btn-edit {\n  background-color: #4caf50;\n  color: #fff;\n}\n\n.wn-btn-edit:hover {\n  background-color: #43a047;\n}\n\n.wn-btn-delete {\n  background-color: #f44336;\n  color: #fff;\n}\n\n.wn-btn-delete:hover {\n  background-color: #d32f2f;\n}\n\n/* ======= LIST / NEWS ITEMS ======= */\n.wn-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.wn-item {\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 12px;\n  padding: 20px;\n  transition: transform 0.15s, box-shadow 0.15s;\n}\n\n.wn-item:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);\n}\n\n.wn-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.wn-item-title {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #1890ff;\n}\n\n.wn-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.wn-content {\n  font-size: 1rem;\n  line-height: 1.6;\n  color: #444;\n  margin-bottom: 8px;\n  white-space: pre-wrap;\n}\n\n.wn-date {\n  font-size: 0.85rem;\n  color: #888;\n  text-align: right;\n}\n\n/* ======= STATES ======= */\n.wn-loading,\n.wn-empty {\n  text-align: center;\n  color: #777;\n  font-size: 1rem;\n  margin-top: 30px;\n}\n\n/* ======= MOBILE (Responsive) ======= */\n@media (max-width: 768px) {\n  .wn-container {\n    padding: 15px 12px 30px;\n  }\n  \n  .wn-list {\n  margin-top: 30px;\n}\n\n\n  .wn-form {\n    padding: 15px;\n  }\n\n  .wn-btn-group {\n    flex-direction: column;\n  }\n\n  .wn-btn {\n    width: 100%;\n  }\n\n  .wn-item {\n    padding: 15px;\n  }\n\n  .wn-item-title {\n    font-size: 1.1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
